export default __webpack_public_path__ + "2993f7b688ae9234b6230d417c0726ab.png";